module.exports = __webpack_public_path__ + "img/Rogue-gnome-f-70.ccd9657f.gif";